import styled from "styled-components";
import { Styles } from "constants/index";

export const Container = styled.div`
  width: 100%;
  ${Styles.RBC};
`;
